/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  RiskMCPPlatformToolset,
  RiskMCPPlatformToolset$inboundSchema,
} from "./riskmcpplatformtoolset.js";

export type ListMCPPlatformToolsetsResult = {
  /**
   * The available Platform MCP policy scope targets.
   */
  toolsets: Array<RiskMCPPlatformToolset>;
};

/** @internal */
export const ListMCPPlatformToolsetsResult$inboundSchema: z.ZodMiniType<
  ListMCPPlatformToolsetsResult,
  unknown
> = z.object({
  toolsets: z.array(RiskMCPPlatformToolset$inboundSchema),
});

export function listMCPPlatformToolsetsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListMCPPlatformToolsetsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListMCPPlatformToolsetsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListMCPPlatformToolsetsResult' from JSON`,
  );
}
